import React, { useState, useRef }  from 'react';
import './App.css';
import * as mediaUtils from  './lib/mediaDeviceUtils.js';
import * as rtcUtils from  './lib/rtcUtils.js';
import * as audioUtils from  './lib/audioUtils.js';
import packageJSON from '../package.json';
import StreamRecorder from './lib/StreamRecorder.js';
import InputAudioEffects from './lib/InputAudioEffects.js';
// import {sleep} from './lib/sleep.js';
import GetConnectionStats from './lib/GetConnectionStats.js';
import TextField from '@material-ui/core/TextField';

const ctx = new (window.AudioContext || window.webkitAudioContext) ();
const mediaDeviceList = 
     {audioInputDevices: [], videoInputDevices: [], audioOutputDevices: []};

let localVideoStream01 = null;
let localVideoStream02 = null;
let localMicStream = null;
let localAudioStream = null;
let recorder = null;
let sendingStream = null;
let localPeer = null;
let remotePeer = null;
let meterPeakGlobal = -60;
let inputAudioEffects = null;
let intervalId = null;
let messageIntervalId = null;

const loopInterval = 5; // in seconds
// const loopInterval = 1; // in seconds

function App() {

  // states
  const [isInitialized, setIsInitialized] = useState(false);
  const [videoInputDevices, setVideoInputDevices] = useState([]);
  const [videoInputDevicesChecked, setVideoInputDevicesChecked] = useState([]);
  const [audioInputDevices, setAudioInputDevices] = useState([]);
  const [audioOutputDevices, setAudioOutputDevices] = useState([]);
  const [micGain, setMicGain] = useState(0); // in dB
  const [meterValue, setMeterValue] = useState(-100); 
  const [meterPeak, setMeterPeak] = useState(meterPeakGlobal); 
  const [connState, setConnState] = useState(false);
  const [localVideo01Enabled, setLocalVideo01Enabled] = useState(true);
  const [localVideo02Enabled, setLocalVideo02Enabled] = useState(true);
  const [textArea, setTextArea] = useState("");
  const [remoteVideo01Playing, setRemoteVideo01Playing] = useState(false);
  const [remoteVideo02Playing, setRemoteVideo02Playing] = useState(false);
  const [recorderNextState, setRecorderNextState] = useState('Record');
    // 'Stop', 'Export'

  const localVideo01 = useRef();
  const localVideo02 = useRef();
  const remoteVideo01 = useRef();
  const remoteVideo02 = useRef();
  const peakMeter = useRef();

  async function constructor() {
    console.log("CONSTRUCTOR");
    setIsInitialized(true);

    try {
      await getMediaDeviceList();
    } catch (err) {console.error(err);}

    navigator.mediaDevices.ondevicechange = getMediaDeviceList;

  }

  const getMediaDeviceList = async () => {

    const list = await mediaUtils.getMediaDeviceList(mediaDeviceList);
    console.log('getMediaDeviceList()',list);

    console.log(list);

    mediaDeviceList.audioInputDevices = list.audioInputDevices;
    mediaDeviceList.videoInputDevices = list.videoInputDevices;
    mediaDeviceList.audioOutputDevices = list.audioOutputDevices;

    setVideoInputDevices(list.videoInputDevices);
    let checked = [];
    list.videoInputDevices.forEach((device,index) => checked[index] = false)

    setVideoInputDevicesChecked(checked);
    setAudioInputDevices(list.audioInputDevices);
    setAudioOutputDevices(list.videoInputDevices);

    return;
  }

  const handleDeviceSelection = async (e) => {
    ctx.resume();

    if (e.target.name === 'video'){
      const device = videoInputDevices[e.target.value];

//      console.log("index: ", e.target.value);
      const checked = videoInputDevicesChecked; 
      checked[e.target.value] = !checked[e.target.value];

//      setVideoInputDevicesChecked(checked);

      if (checked[e.target.value] === true){

        console.log('Open Camera: ',
         device.label, device.deviceId, device.groupId); 

          const newVideoStream = new MediaStream();
          const videoconstraints = {
            deviceId: {exact: device.deviceId},
            width: {ideal: 1920}, height: {ideal: 1080}
          };

        const newTrack = await mediaUtils.getCameraTrack(videoconstraints)
        newVideoStream.addTrack(newTrack); 
        if ( (localPeer && sendingStream) &&
          (localVideoStream01 === null || localVideoStream02 === null)){
           localPeer.addTrack(newTrack, sendingStream);
        }

        if (localVideoStream01 === null) {
          localVideoStream01 
             = {stream: newVideoStream, deviceId: device.deviceId};
          localVideo01.current.srcObject = newVideoStream;
          console.log('localVideo01:', 
             localVideo01.current.srcObject.getTracks()[0].id);
        } else if (localVideoStream02 === null){
          localVideoStream02 
           = {stream: newVideoStream, deviceId: device.deviceId}; 
          localVideo02.current.srcObject = newVideoStream;
          console.log('localVideo02:', 
             localVideo02.current.srcObject.getTracks()[0].id);
        } else {
          console.error ('Max camera 2');
          await newTrack.stop();
        }

      } else { 
        console.log('Close Camera: ',
         device.label, device.deviceId, device.groupId); 

        if (localVideoStream01 !== null 
            && localVideoStream01.deviceId === device.deviceId){ 

            if (localPeer) 
              rtcUtils.removeTrack(localPeer, 
                localVideoStream01.stream.getTracks()[0]);

            await localVideoStream01.stream.getTracks()[0].stop();
            localVideoStream01 = null;
            localVideo01.current.srcObject = null;
        }

        if (localVideoStream02 !== null 
            && localVideoStream02.deviceId === device.deviceId) {

            if (localPeer) 
              rtcUtils.removeTrack(localPeer, 
                localVideoStream02.stream.getTrack()[0]);

            await localVideoStream02.stream.getTracks()[0].stop();
            localVideoStream02 = null;
            localVideo02.current.srcObject = null;
        } 

      }

     setVideoInputDevicesChecked(checked);

    }

    if (e.target.name === 'audio'){ // audio device selection

      const device = audioInputDevices[e.target.value];

      if (localMicStream !== null) {
        console.log('Close audio track:', localMicStream.getTracks()[0].id);
        localMicStream.getTracks()[0].stop();
        inputAudioEffects.close();
        inputAudioEffects = null;
      }

      console.log('Open audio track: ', device.label,
             device.deviceId, device.groupId); 

      const audioConstraints = {
            deviceId: {exact: device.deviceId},
            autoGainControl: false,
            noiseSuppression: false,
            echoCancellation: false,
            latency: {ideal: 0.0}
      };

      const micTrack = await mediaUtils.getMicTrack(audioConstraints);

      localMicStream = new MediaStream ([micTrack]);

      console.log('micTrack settings', micTrack.getSettings());

      inputAudioEffects = new InputAudioEffects(localMicStream,meterCallback);

      let previous = null;
      if (localAudioStream !== null) previous = localAudioStream.stream;

      localAudioStream = {stream: inputAudioEffects.getOutputStream(),
           deviceId: device.deviceId};

      if (previous && localPeer)
        rtcUtils.replaceTrack(localPeer,previous.getTracks()[0],
               localAudioStream.stream.getTracks()[0]);

    }

  }

  const handleMicGain = (event) => {
    const gain = parseFloat(event.target.value);
    setMicGain(gain);
    if (inputAudioEffects) inputAudioEffects.setGain(gain);
  };

  const meterCallback = (peakPowerDB) => {
     setMeterValue(peakPowerDB);   
     if (peakPowerDB > meterPeakGlobal) meterPeakGlobal = peakPowerDB;
     setMeterPeak (meterPeakGlobal);
  };

// Call from local
  const handleCall = async (e) => {

   if (connState) {
     localPeer.close();
     sendingStream = null;
     remotePeer.close();
     setConnState(false);
     if (intervalId !== null) clearInterval(intervalId);
     if (messageIntervalId !== null) clearInterval(messageIntervalId);

     return;
   }

    let retval = null;
    sendingStream = new MediaStream();

    const tmp = [localVideoStream01, localVideoStream02, localAudioStream];

    tmp.forEach ((streamName) => {
      if(streamName !== null){ 
        sendingStream.addTrack(streamName.stream.getTracks()[0]);
      }
    });

    try {
      retval = await rtcUtils.localRTCPeerConnection(sendingStream,
        gotRemoteStreams, gotRemoteTrack);
      localPeer = retval.localPeer;
      remotePeer = retval.remotePeer;
      setConnState(true);
    } catch(e) { console.error(e);}

   // data channel
    const lDC = localPeer.createDataChannel("command channel");
    lDC.onmessage = (e) => {console.log('local recvd: ' + e.data);}
    lDC.onopen = (e) => {console.log('local dc open: ');}
    lDC.onclose = (e) => {console.log('local dc closed: ');}

/*
    const sendMessage = () => { lDC.send('message');}
    messageIntervalId = setInterval(sendMessage,loopInterval*1000); // in msec
*/

    try {
      let bpmString = "";
      let localStats = new GetConnectionStats(localPeer);
      const loop = async () => {
        let currentStats = await localStats.getStats();
        bpmString += currentStats + "---\n";
        setTextArea(bpmString);
      }

      intervalId = setInterval(loop,loopInterval*1000); // in msec

    } catch(e) {console.error(e);}
  };

  // remotePeer 
  const gotRemoteStreams = (streams) => { // only streams[0] is used
    // called twice?

    const videoTracks = [];
    const audioTracks = [];

    streams[0].getTracks().forEach (track => {
      // console.log('recving track', track.kind, track.id);
      if (track.kind === 'video') videoTracks.push(track);
      else if (track.kind === 'audio') audioTracks.push(track);
    });

    if (videoTracks[0]){ 
      remoteVideo01.current.pause();
      remoteVideo01.current.srcObject = new MediaStream([videoTracks[0]]);
      console.log('remoteVideo01: ', 
            remoteVideo01.current.srcObject.getTracks()[0].id);
      setRemoteVideo01Playing(true);
    } if (videoTracks[1]) { 
      remoteVideo02.current.pause();
      remoteVideo02.current.srcObject = new MediaStream([videoTracks[1]]);
      console.log('remoteVideo02: ', 
            remoteVideo02.current.srcObject.getTracks()[0].id);
      setRemoteVideo02Playing(true);
    }

    if (audioTracks[0]) {

      console.log('receiving audio', audioTracks[0].id);

      //audioUtils.playAudioStream(ctx,new MediaStream([audioTracks[0]]));
      audioUtils.playAudioStreamWithAudioElement(
        new MediaStream([audioTracks[0]])
      );
    }
   
  }; 

  const gotRemoteTrack = (track) => { 
     console.log('gotRemoteTrack');

     if (track.kind === 'audio') console.log("Can't add audio track");

     if (track.kind === 'video') {
        console.log('recving new video track', track.kind, track.id);
        if (!remoteVideo01Playing){
          remoteVideo01.current.srcObject = new MediaStream([track]);
          console.log('remoteVideo01: ', 
            remoteVideo01.current.srcObject.getTracks()[0].id);
          setRemoteVideo01Playing(true);
        } else if (!remoteVideo02Playing){
          remoteVideo02.current.srcObject = new MediaStream([track]);
          console.log('remoteVideo01: ', 
            remoteVideo01.current.srcObject.getTracks()[0].id);
          setRemoteVideo02Playing(true);
        } else {
          console.log('sorry, receiving 2 videos already (max 2)');
        }
     }
  };

  function toggleVideo(e) {
    // console.log ('toggleVideo:', e.target);

    if (e.target.name !== 'disableVideo') return;

    if (e.target.value === 'localVideo01' 
      && localVideoStream01 !== null) {
      localVideoStream01.stream.getVideoTracks()[0].enabled 
        = !localVideo01Enabled;

      console.log('localVideo01 enabled', !localVideo01Enabled); //fake 
      console.log('remoteVideo01 source track.id', 
          remoteVideo01.current.srcObject.track.id);

      if (localVideo01Enabled) 
         remoteVideo01.current.style.display = 'none';
      else
         remoteVideo01.current.style.display = '';
      setLocalVideo01Enabled(!localVideo01Enabled);
    } 

    if (e.target.value === 'localVideo02' 
       && localVideoStream02 !==null){
      localVideoStream02.stream.getVideoTracks()[0].enabled 
       = !localVideo02Enabled;

      console.log('localVideo02 enabled', !localVideo02Enabled); // fake 
      console.log('remoteVideo02 source track.id', 
          remoteVideo02.current.srcObject.track.id);

      if (localVideo02Enabled)
        remoteVideo02.current.style.display = 'none';
      else
        remoteVideo02.current.style.display = '';
      setLocalVideo02Enabled(!localVideo02Enabled);  
    }
    
  }

  function handleRecorder (e) {

    if (e.target.value === 'Record'){
      const recordingStream = new MediaStream();
      const tmp = [localVideoStream01,localVideoStream02, localAudioStream];

      tmp.forEach(element => {
        if (element && element.stream.getTracks().length > 0) {
          const track = element.stream.getTracks()[0];
          recordingStream.addTrack(track);
          console.log('Record: ', track.id);
        }
      });

      if (recordingStream.getTracks().length > 0) {
        recorder = new StreamRecorder(recordingStream); 
        recorder.start();
        setRecorderNextState('Stop'); 
      }

      return; 
    }

    if (e.target.value === 'Stop'){
      if (recorder) recorder.stop();
      setRecorderNextState('Export'); return; 
    }

    if (e.target.value === 'Export'){
      if (recorder) recorder.exportFile('lecturer');
      setRecorderNextState('Record'); return; }
  }

// main
  if (!isInitialized) constructor();

  return (
    <div className="App">
    <b>WebRTC client (loopback)</b>&emsp; 
    <button name="call" value="local" onClick={handleCall}>
    {connState? 'HangUp' : 'Call'}</button> &emsp;

    <button value={recorderNextState} onClick={handleRecorder} >
      {recorderNextState}</button>
<hr/>
    Camera input (max 2): &emsp; 
    {videoInputDevices.map((device,index) => 
      <span key={index}>
      <label><input type="checkbox" name="video" value={index}
       onChange={handleDeviceSelection} />
      {device.label}
      </label>
     </span>
    )}
    <br/>
    Audio Input (only one): &emsp;
    {audioInputDevices.map((device,index) => 
     <span key={index}>
       <label>
       <input type="radio" name="audio" value={index} 
        onChange={handleDeviceSelection} />
       {device.label}
       </label>
     </span>
    )}
<hr/>
<div>
     MicGain(dB): &emsp;<input type='range' name='micGain'
         min={-24} max={24} step={1}
         value ={micGain} onChange = {handleMicGain} 
         style={{width: '20%'}} /> 
       &nbsp;{ micGain >= 0 ? 
          "+" + ('0000' + Math.abs(micGain)).slice(-2)
          : "-" + ('0000' + Math.abs(micGain)).slice(-2) }<br/>
     &nbsp; <button 
          onClick={(e) => meterPeakGlobal = -60}>Reset peak</button>
     &nbsp;&nbsp;-36&nbsp;
     <meter ref={peakMeter} min={-36} high={-3} max={10} value={meterValue}
     style={{width: '20%'}}></meter>&nbsp;10, Peak {meterPeak.toFixed(1)}
</div>
<hr/>
<table border="2">
<thead>
    <tr><th>localVideo01 &emsp; 
    <button name="disableVideo" value="localVideo01" onClick={toggleVideo}>
    {localVideo01Enabled ? 'Disable' : 'Enable'}
    </button>
    </th><th>remoteVideo01 
    </th></tr>
</thead>
<tbody>
   <tr><td>
    <video ref={localVideo01} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    <td><video ref={remoteVideo01} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
   </tr>
</tbody>
<thead>
   <tr><th>localVideo02 &emsp;
    <button name="disableVideo" value="localVideo02" onClick={toggleVideo}>
    {localVideo02Enabled ? 'Disable' : 'Enable'}</button>
   </th><th>remoteVideo02</th>
   </tr> 
</thead>
<tbody>
    <tr>
    <td><video ref={localVideo02} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    <td><video ref={remoteVideo02} autoPlay playsInline muted
      style={{width: '480px'}} /></td>
    </tr>
</tbody>
</table>
    <hr/>
<div>
<b>Statistics</b>
<div>
<TextField value={textArea} multiline cols={100} maxRows={15} 
 fullWidth />
</div>
<hr/>
</div>
<div>
Version: {packageJSON.version}
</div>
</div>
  );
}

export default App;
